import FollowingIndexComponent from '@/views/following/index';

export default [
  {
    path: '/following',
    name: 'following#index',
    component: FollowingIndexComponent,
    meta: {
      masteryHeader: true,
      previewer: true,
    },
  },
];